import React from "react";
import { Helmet } from "react-helmet-async";

function HealingAndTherapies() {
    return (
      <div>
      <Helmet>
        <title>Healings & Therapies | Adya Yoga</title>
        <meta
          name="description"
          content="Energy therapies including Aura Reading, Chakra Balancing, Reiki, Animal Communication, Flower Essences and more."
        />
        <link rel="canonical" href="https://yogaadya.com/healing-and-therapies" />
        <meta name="robots" content="index, follow" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Adya Yoga" />
        <meta property="og:title" content="Healings & Therapies | Adya Yoga" />
        <meta property="og:description" content="Holistic therapies by Jigyasa: Aura Reading, Chakra Balancing, Reiki and more." />
        <meta property="og:url" content="https://yogaadya.com/healing-and-therapies" />
        <meta property="og:image" content="https://yogaadya.com/assets/images/aura-reading.webp" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Healings & Therapies | Adya Yoga" />
        <meta name="twitter:description" content="Holistic energy therapies by Jigyasa." />
        <meta name="twitter:image" content="https://yogaadya.com/assets/images/aura-reading.webp" />
      </Helmet>
      {/*  service */}
<section class="py-md-3 py-sm-3 py-3" id="healing-therapies">
<div className="events-retreats-container">
    {/* Header Section */}
    <div className="events-header">
                        <h1 className="events-title">Healings & Therapies</h1>
                        
      </div>

    {/*  Listing 1 */}
    <div class="therapy-item">
      <img src="assets/images/aura-reading.webp" alt="Therapy 1" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Aura Reading</h4>
        <p>
        Aura Reading or Scan tells you the exact state of your aura and your chakras. Your
stress levels, disharmony in your yin-yang balance, the energy efficacy of each
chakra, and in depth understanding of your personality are all discussed, making this
a comprehensive study of yourself. This helps you develop your strengths and
uncover your hidden potential.</p>
<p> Its a great way to know what your energy tells about you, how to make you and your
life better, to return to your true self. Its a pathway to regain the energy you were
born with. You become aware of the condition of your energy body, get to know of
the condition in details; both positive and negative.</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 45 minutes. <br></br>
Possible via Distance:- Yes</p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>

    {/*  Listing 2 */}
    <div class="therapy-item">
      <img src="assets/images/chakra-balancing.webp" alt="Therapy 2" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Chakra Balancing</h4>
        <p>
        There are main 7 main energy centres in our body, widely known as Chakras. Each
Chakra has an assigned function that correlates to specific body ailments, physical
dysfunction etc. Every Chakra houses our mental and emotional strengths. Clearing
and Balancing of Chakras can balance our emotional state of mind, promoting
overall balance and harmony.</p>
<p>
Other than millions of physical health benefits, Chakra Balancing gives greater
capacity to express and attract positivity in your life. Feel clear and free and
experience the unfolding of the &quot;Spiritual Self&quot;. Balanced Chakras equals to a
Balanced Life.
</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 45 minutes. <br></br>
Possible via Distance:- Yes</p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>

    {/*  Listing 3 */}
    <div class="therapy-item">
      <img src="assets/images/reiki.webp" alt="Therapy 3" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Reiki</h4>
        <p>
        Reiki is a healing therapy based on the principle that a healer acting as a medium
can channel and pass energy into the body of the receiver by the medium of subtle
touch. This activates the natural healing processes of the receiver&#39;s body and
restores physical and emotional well-being.</p>
<p>
With a session of Reiki healing each cell of your body will vibrate energy and health.
It nourishes your mind, body and soul. Along with healing physical ailments, it
strongly enhances your Aura and activates your Chakras.</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 45 minutes. <br></br>
Possible via Distance:- Yes</p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>

    {/*  Listing 4 */}
    <div class="therapy-item">
      <img src="assets/images/AnimalCommunication.webp" alt="Therapy 4" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Animal Communication</h4>
        <p>
        Would you like to talk to your Fur kid?<br></br>
Is there something you want to ask them?<br></br>
Is there something you want to tell them?<br></br>
Are you having difficulties conveying your message and feelings?<br></br>
Choose a medium to connect to your animals and speak to them in their language.<br></br>
Animals are the ones living in the highest meditative state. May be that&#39;s why many
times it&#39;s difficult for the chattering human being to connect to them. They would feel
 amazing if you could give your message to your pet but in their frequency.<br></br>
 All you need is a recent photo of your Pet. If deceased, last available picture will do.<br></br>
</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 45 mins+/-<br></br>
Possible via Distance:- Yes</p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>

    {/*  Listing 5 */}
    <div class="therapy-item">
      <img src="assets/images/FlowerEssenceTherapy.webp" alt="Therapy 5" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Flower Essence Therapy</h4>
        <p>
        Get a consultation and a mix of Flower essences most needed for you.<br></br>

Flower Essences heal pain and suffering at physical, mental and emotional levels.<br></br>  
Very helpful in Stress, Depression/Anxiety, Fears/Phobias, Addictions, Anger,
Thyroid, PCOD, Weight imbalance, Allergies, Migraine, Sciatica, Sinus or Asthma,
Pains etc.<br></br>

Flower remedies helps personal and professional growth. It helps in getting rid of
traumas, old belief patterns, teenage issues etc. Flower essences are great in
creating harmony in family , office and also helps in resolving conflicts.<br></br>

It&#39;s is a safe alternative therapy without any side effects. These can be used by
anyone be it Kids, Adults, Pregnant Ladies, Nursing Mothers, Seniors and you can
 give these to your Pets as well.<br></br>
</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 45 mins+/-<br></br>
Possible via Distance:- Consultation- Yes</p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>

    {/*  Listing 6 */}
    <div class="therapy-item">
      <img src="assets/images/MarmaFaceMassage.webp" alt="Therapy 6" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Marma Face Massage:-</h4>
        <p>
        As per Ayurveda, Marma Points are pressure points in the whole body which can
help us heal and bring a balance in our Life. They work on re-energising the
channels in our body. When Marma points are active, body is kept fully informed and
can easily heal itself. There are 108 Marma points in our complete body, out of which
some of the major points are on the Face, Neck and Head. These points help in
functioning of all our 5 senses and open all our upper energy channel points. So
 consider this an Energetic Facelift with spiritual benefits.<br></br>
</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 30 mins+/-<br></br></p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>

          {/*  Listing 7 */}
          <div class="therapy-item">
      <img src="assets/images/MassageBajarLaMadre.webp" alt="Therapy 6" class="therapy-img"/>
      <div class="therapy-content">
        <h4>Massage Bajar La Madre</h4>
        <p>
        This &quot;massage&quot;, an ancestral healing technique is carried out in the belly of the
person and the intention is to undo the energy blocks in the Solar Plexus and in the
&quot;path&quot; (Hara Line) between the Solar Plexus and the Sacral chakra.
Some Benefits of this massage are Weight Balance, Reduction of Bloating, Relief
from constipation, Overall gastrointestinal wellness, Improved menstrual symptoms,
Increased abdominal muscle tone, Improved digestion, Stress reduction, Stimulate
internal organs, Release of blocked emotions, Balanced Apetite, Increased flexibility,
Relief from lower back and abdominal pains, Improved respiration capacity,
 Improves circulation and blood supply to the organs of abdominal cavity<br></br>
</p>
<div class="d-flex justify-content-between align-items-center">
<p class="mb-0">Time Duration- 30 mins+/-<br></br></p>
<a href="/contact" className="register-btn">Book Now</a>
        </div>
      </div>
    </div>



  </div>
</section>

      </div>
    )
}

export default HealingAndTherapies